import React from 'react';
import { QueryBuilder, ConvertQuery } from '../../../components';

const schema = {
  uuid: 'fafdde66-6169-46bf-926f-49c6f93dc89c',
  condition: 'and',
  title: 'Query',
  rules: [{
    field: 'GriVolt1',
    type: 'numeric',
    uuid: 'df5542ee-a1c0-4c96-a71c-7c0b2c67691d',
    value: 14,
  }, {
    field: 'TurError',
    operator: '>',
    type: 'nvarchar',
    uuid: 'df5542ee-a1c0-4c96-a712-7c0b2c67691d',
    value: '',
  }, {
    field: 'TurError',
    type: 'nvarchar',
    uuid: 'df5542ee-a130-4c96-a712-7c0b2c67691d',
    value: 'Value',
  }, {
    uuid: 'fafdde66-6169-46bf-926f-49c6f93dc89c',
    condition: 'or',
    rules: [{
      field: 'OPCTimeStamp',
      operator: '>',
      type: 'datetime',
      uuid: 'df5542ee-a1c0-4c96-a71c-7c0b2c67691d',
      value: '22.05.2018 11:12:13',
    }, {
      field: 'RealDate',
      type: 'datetime',
      operator: '<',
      uuid: 'df5542ee-a1c0-4c96-a712-7c0b2c67691d',
      value: '22.06.2019 01:35:00',
    }, {
      field: 'ID',
      type: 'bit',
      uuid: 'df5542ee-a1c0-4c96-a712-7c0b2347691d',
      value: true,
    }],
  }],
};

const fields = [
  {
    name: 'ID',
    type: 'int',
  }, {
    name: 'TurError',
    type: 'nvarchar',
  }, {
    name: 'BIT',
    type: 'bit',
  }, {
    name: 'GriVolt1',
    type: 'numeric',
  }, {
    name: 'GriVolt2',
    type: 'numeric',
  }, {
    name: 'GriVolt3',
    type: 'numeric',
  }, {
    name: 'GriCurL1',
    type: 'numeric',
  }, {
    name: 'GriCurL2',
    type: 'numeric',
  }, {
    name: 'GriCurL3',
    type: 'numeric',
  }, {
    name: 'PwrApp',
    type: 'numeric',
  }, {
    name: 'PwrAct',
    type: 'numeric',
  }, {
    name: 'PwrReact',
    type: 'numeric',
  }, {
    name: 'CosPhi',
    type: 'numeric',
  }, {
    name: 'WSpd',
    type: 'numeric',
  }, {
    name: 'WDir',
    type: 'numeric',
  }, {
    name: 'GnSpd',
    type: 'numeric',
  }, {
    name: 'RotSpd',
    type: 'numeric',
  }, {
    name: 'HydPres',
    type: 'numeric',
  }, {
    name: 'GnTmpOutlet',
    type: 'numeric',
  }, {
    name: 'RealDate',
    type: 'datetime',
  }, {
    name: 'OPCTimeStamp',
    type: 'datetime',
  }, {
    name: 'Part1RealDate',
    type: 'nvarchar',
  }, {
    name: 'Part2RealDate',
    type: 'nvarchar',
  }, {
    name: 'ExtTmp',
    type: 'numeric',
  },
];

class DevQueryBuilder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      output1: {},
      output2: {},
      output3: {},
    };

    this.outputUpdate1 = this.outputUpdate1.bind(this);
    this.outputUpdate2 = this.outputUpdate2.bind(this);
    this.outputUpdate3 = this.outputUpdate3.bind(this);
  }

  outputUpdate1(output1) {
    this.setState({ output1 });
  }

  outputUpdate2(output2) {
    this.setState({ output2 });
  }

  outputUpdate3(output3) {
    this.setState({ output3 });
  }

  render() {
    const { output1, output2, output3 } = this.state;

    return (
      <div>
        <section>
          <h4>Query Builder</h4>
          <p>
            Herhangi bir parametre vermeden,
            varsayılan verilen ile oluşturulan Query Builder örneği.
          </p>
          <h6>Converted SQL query</h6>
          <p><code>{ConvertQuery(output1)}</code></p>
          <QueryBuilder
            debug
            fields={fields}
            output={this.outputUpdate1}
            title="Query Builder 1"
          />
          <pre>
            {JSON.stringify(output1, null, 2)}
          </pre>
        </section>
        <br />
        <br />
        <section>
          <h4>Mobile Query Builder</h4>
          <p>
            Mobile uygulamalara özel özelleştirilmiş Query Builder örneği.
          </p>
          <h6>Converted SQL query</h6>
          <p><code>{ConvertQuery(output2)}</code></p>
          <QueryBuilder
            // debug
            fields={fields}
            output={this.outputUpdate2}
            title="Query Builder 2"
            isMobile
          />
          <pre>
            {JSON.stringify(output2, null, 2)}
          </pre>
        </section>
        <br />
        <br />
        <section>
          <h4>Query Builder: Schema</h4>
          <p>Örnek bir şema ile oluşturulan Query Builder örneği.</p>
          <h6>Converted SQL query</h6>
          <p><code>{ConvertQuery(output3)}</code></p>
          <QueryBuilder
            // debug
            fields={fields}
            output={this.outputUpdate3}
            schema={schema}
            title="Query Builder 3"
          />
          <pre>
            {JSON.stringify(output3, null, 2)}
          </pre>
        </section>
      </div>
    );
  }
}

export default DevQueryBuilder;
